if ($('.in-404').length) {
    $('h1 + h2').after($('#footer .text_404').clone());

  
    if (!$('.categories').length) {
        if (sessionStorage.loadedCategories) {
            $('.empty-content').append('<div class="categories">' + sessionStorage.loadedCategories + '</div>');
            if (sessionStorage.reviewsWrap) {
                $('.empty-content').append('<div class="reviewsWrap">' + sessionStorage.reviewsWrap + '</div>');
            }

        } else {

            $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 10000,
                cache: true,
                url: "/",
                success: function (e) {
                    var doc = shoptet.common.createDocumentFromString(e);

                    // Kategorie
                    var categoriesHtml = $(doc).find(".categories").html();
                    if (categoriesHtml !== null) {
                        $('.empty-content').append('<div class="categories">' + categoriesHtml + '</div>');
                        sessionStorage.loadedCategories = categoriesHtml;
                    }

                    // reviewsWrap
                    var reviewsWrapHtml = $(doc).find(".reviewsWrap").html();
                    if (reviewsWrapHtml !== null) {
                        $('.empty-content').append('<div class="reviewsWrap">' + reviewsWrapHtml + '</div>');
                        sessionStorage.reviewsWrap = reviewsWrapHtml;
                    }
                }
            });
        }
    }
}